module.exports = __webpack_public_path__ + "static/media/Search.67dc64ab.svg";